import emailjs from 'emailjs-com';

const EMAILJS_SERVICE_ID = 'service_thxt3z1';
const EMAILJS_TEMPLATE_ID = 'template_dhefstm';
const EMAILJS_SELL_INQUIRY_TEMPLATE_ID = 'template_08q2jl9';
const EMAILJS_PUBLIC_KEY = 'TNlqZ6-E4lnDKte3t';

const formatLabel = (key) => key
  .replace(/([a-z])([A-Z])/g, '$1 $2')
  .replace(/[_-]/g, ' ')
  .replace(/\b\w/g, (letter) => letter.toUpperCase());

const buildMessage = (fields) => Object.entries(fields)
  .filter(([, value]) => value !== undefined && value !== null && String(value).trim() !== '')
  .map(([key, value]) => `${formatLabel(key)}: ${value}`)
  .join('\n');

export const sendContactEmail = (fields, pageName) => {
  const name = fields.name || fields.firstName || fields.fullName || 'Website visitor';
  const email = fields.email || '';

  return emailjs.send(
    EMAILJS_SERVICE_ID,
    EMAILJS_TEMPLATE_ID,
    {
      subject: `Contact Us: ${pageName}`,
      name,
      email,
      reply_to: email,
      page: pageName,
      time: new Date().toLocaleString(),
      message: buildMessage(fields),
    },
    EMAILJS_PUBLIC_KEY,
  );
};

export const sendSellInquiryEmail = (fields) => {
  const name = fields.name || 'Website visitor';
  const email = fields.email || '';

  return emailjs.send(
    EMAILJS_SERVICE_ID,
    EMAILJS_SELL_INQUIRY_TEMPLATE_ID,
    {
      subject: 'Sell Your Business Inquiry',
      name,
      email,
      reply_to: email,
      page: 'Sell Your Business',
      time: new Date().toLocaleString(),
      phone: fields.phone || '',
      nationality: fields.nationality || '',
      company_name: fields.companyName || '',
      industry: fields.industry || '',
      location: fields.location || '',
      company_website: fields.companyWebsite || '',
      years_operating: fields.yearsOperating || '',
      summary: fields.summary || '',
      message: buildMessage(fields),
    },
    EMAILJS_PUBLIC_KEY,
  );
};
